import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Divider,
} from '@mui/material';

const Impressum = () => {
  return (
    <Box sx={{ py: { xs: 4, md: 8 }, backgroundColor: 'background.paper' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            mb: 6,
            color: 'text.primary',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          Rechtliche Informationen
        </Typography>

        {/* Navigation between sections */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
            Springen zu:
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, flexWrap: 'wrap' }}>
            <a href="#impressum" style={{ textDecoration: 'none', color: '#1976d2', fontWeight: 'bold' }}>
              Impressum
            </a>
            <a href="#datenschutz" style={{ textDecoration: 'none', color: '#1976d2', fontWeight: 'bold' }}>
              Datenschutz
            </a>
          </Box>
        </Box>

        <Typography
          id="impressum"
          variant="h3"
          sx={{
            mb: 4,
            color: 'text.primary',
            fontWeight: 'bold',
            textAlign: 'center',
            borderBottom: '2px solid',
            borderColor: 'primary.main',
            pb: 2,
          }}
        >
          Impressum
        </Typography>

        {/* Diensteanbieter Section */}
        <Paper
          elevation={2}
          sx={{
            p: 3,
            mb: 4,
            backgroundColor: 'grey.50',
            borderRadius: 3,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
            Diensteanbieter
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            DAD-Service Aleksandar Danilovic & Tuma Barhe GbR
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Breslauerstraße 44
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            60598 Frankfurt
          </Typography>

          <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
            Vertreten durch:
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Aleksandar Danilovic & Tuma Barhe
          </Typography>
        </Paper>

        {/* Kontakt Section */}
        <Paper
          elevation={2}
          sx={{
            p: 3,
            mb: 4,
            backgroundColor: 'grey.50',
            borderRadius: 3,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
            Kontakt
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Telefon: <a href="tel:015906794985" style={{ color: '#1976d2', textDecoration: 'none' }}>0159 067 949 85</a>
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            E-mail: <a href="mailto:info@dad-service.de" style={{ color: '#1976d2', textDecoration: 'none' }}>info@dad-service.de</a>
          </Typography>
        </Paper>

        {/* Berufs-Haftpflichtversicherung Section */}
        <Paper
          elevation={2}
          sx={{
            p: 3,
            mb: 4,
            backgroundColor: 'grey.50',
            borderRadius: 3,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
            Angaben zur Berufs-Haftpflichtversicherung
          </Typography>
          <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
            Name und Sitz des Versicherers:
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Baloise Sachversicherung AG Deutschland
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Baslerstraße 4
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            61345 Bad Homburg
          </Typography>
        </Paper>

        {/* EU-Streitschlichtung Section */}
        <Paper
          elevation={2}
          sx={{
            p: 3,
            mb: 4,
            backgroundColor: 'grey.50',
            borderRadius: 3,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
            EU-Streitschlichtung
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            <a
              href="https://ec.europa.eu/consumers/odr/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1976d2', textDecoration: 'none' }}
            >
              https://ec.europa.eu/consumers/odr/
            </a>
          </Typography>
          <Typography variant="body1">
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </Typography>
        </Paper>

        {/* Verbraucher-Streitbeilegung Section */}
        <Paper
          elevation={2}
          sx={{
            p: 3,
            mb: 4,
            backgroundColor: 'grey.50',
            borderRadius: 3,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
            Verbraucher-Streitbeilegung/Universal-Schlichtungsstelle
          </Typography>
          <Typography variant="body1">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </Typography>
        </Paper>

        <Divider sx={{ my: 4 }} />

        <Typography
          id="datenschutz"
          variant="h3"
          sx={{
            mb: 4,
            color: 'text.primary',
            fontWeight: 'bold',
            textAlign: 'center',
            borderBottom: '2px solid',
            borderColor: 'primary.main',
            pb: 2,
            mt: 8,
          }}
        >
          Datenschutzerklärung
        </Typography>

        {/* Datenschutz auf einen Blick */}
        <Paper
          elevation={2}
          sx={{
            p: 3,
            mb: 4,
            backgroundColor: 'grey.50',
            borderRadius: 3,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
            1. Datenschutz auf einen Blick
          </Typography>
          <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
            Allgemeine Hinweise
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
          </Typography>
          <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
            Datenerfassung auf dieser Website
          </Typography>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
            Wer ist verantwortlich für die Datenerfassung auf dieser Website?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt "Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
          </Typography>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
            Wie erfassen wir Ihre Daten?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
          </Typography>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
            Wofür nutzen wir Ihre Daten?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
          </Typography>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
            Welche Rechte haben Sie bezüglich Ihrer Daten?
          </Typography>
          <Typography variant="body1">
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
          </Typography>
        </Paper>

        {/* Hosting Section */}
        <Paper
          elevation={2}
          sx={{
            p: 3,
            mb: 4,
            backgroundColor: 'grey.50',
            borderRadius: 3,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
            2. Hosting
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
          </Typography>
          <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
            Strato
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Anbieter ist die Strato AG, Otto-Ostrowski-Straße 7, 10249 Berlin (nachfolgend "Strato"). Wenn Sie unsere Website besuchen, erfasst Strato verschiedene Logfiles inklusive Ihrer IP-Adressen.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Weitere Informationen entnehmen Sie der Datenschutzerklärung von Strato:
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            <a
              href="https://www.strato.de/datenschutz/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1976d2', textDecoration: 'none' }}
            >
              https://www.strato.de/datenschutz/
            </a>
          </Typography>
          <Typography variant="body1">
            Die Verwendung von Strato erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TTDSG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne des TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.
          </Typography>
          <Typography variant="h6" sx={{ mb: 1, mt: 2, fontWeight: 'bold' }}>
            Auftragsverarbeitung
          </Typography>
          <Typography variant="body1">
            Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.
          </Typography>
        </Paper>

        {/* Additional legal sections would continue here - abbreviated for brevity */}
        <Paper
          elevation={2}
          sx={{
            p: 3,
            mb: 4,
            backgroundColor: 'grey.50',
            borderRadius: 3,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
            Hinweis zur verantwortlichen Stelle
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            DAD-Service Aleksandar Danilovic & Tuma Barhe GbR
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Breslauerstraße 44
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            60598 Frankfurt
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Telefon: <a href="tel:015906794985" style={{ color: '#1976d2', textDecoration: 'none' }}>0159 067 949 85</a>
          </Typography>
          <Typography variant="body1">
            E-mail: <a href="mailto:info@dad-service.de" style={{ color: '#1976d2', textDecoration: 'none' }}>info@dad-service.de</a>
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Impressum;